import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";
import "../css/returns.scss";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function Returns() {
  return (
    <main className="content-page returns-page">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/returns" />

        <article className="content-page__article" aria-labelledby="returns-title">
          <header className="content-page__header">
            <p className="content-page__eyebrow">Straightforward customer care</p>
            <h1 id="returns-title">Returns &amp; Replacements</h1>
            <p className="content-page__lead">
              If an order is not right, tell us what happened. sickzuno customer
              care will review the details and help identify a practical next step.
            </p>
          </header>

          <p className="content-page__meta">Last updated: October 16, 2026</p>

          <div className="content-page__notice" role="note">
            <strong>Return information:</strong> contact us before sending an item back
            so the team can confirm eligibility and the correct return instructions.
          </div>

          <section className="content-page__callout" aria-labelledby="satisfaction-title">
            <h2 id="satisfaction-title">A satisfaction-first approach</h2>
            <p>
              Unopened, eligible products may be considered for exchange or refund.
              Products that arrive damaged or incorrectly packed should be reported
              within 30 days so the team can review a replacement.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="return-start">
            <h2 id="return-start">Before you send anything back</h2>
            <ol className="content-page__steps">
              <li className="content-page__step">
                <h3>Keep the order details</h3>
                <p>Save the packing slip, product packaging and a photo of any damage.</p>
              </li>
              <li className="content-page__step">
                <h3>Contact customer care</h3>
                <p>
                  Share the order reference, affected item and whether you prefer a
                  replacement or refund review.
                </p>
              </li>
              <li className="content-page__step">
                <h3>Wait for instructions</h3>
                <p>
                  The team will confirm eligibility and provide the correct return
                  directions before a parcel is mailed.
                </p>
              </li>
            </ol>
          </section>

          <section className="content-page__section" aria-labelledby="return-review">
            <h2 id="return-review">What the team will review</h2>
            <div className="returns-page__review-grid">
              <article className="content-page__card">
                <h3>Condition</h3>
                <p>Whether the safety seal and original packaging remain intact.</p>
              </article>
              <article className="content-page__card">
                <h3>Timing</h3>
                <p>When the package arrived and when the concern was reported.</p>
              </article>
              <article className="content-page__card">
                <h3>Order record</h3>
                <p>The item, size and quantity listed on the purchase confirmation.</p>
              </article>
              <article className="content-page__card">
                <h3>Resolution</h3>
                <p>Whether replacement, store assistance or refund review fits best.</p>
              </article>
            </div>
          </section>

          <section className="content-page__section" aria-labelledby="return-exceptions">
            <h2 id="return-exceptions">Food-safety exceptions</h2>
            <div className="returns-page__exception">
              <p>
                Opened food products generally cannot be returned for preference-based
                reasons. Extra restrictions can apply to bulk packages, opened liquid
                extracts and large-count specialty ingredients. A verified packing or
                quality issue will still be reviewed by customer care.
              </p>
            </div>
            <p>
              When trying an unfamiliar ingredient, consider a smaller size before
              committing to a bulk quantity.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="return-refunds">
            <h2 id="return-refunds">Refund timing</h2>
            <p>
              After an approved return is received and inspected, a refund would be
              directed to the original payment method where possible. We initiate an
              approved refund promptly after inspection; bank processing times vary and
              are outside the storefront’s control.
            </p>
            <p>
              Shipping questions are covered separately in our{" "}
              <Link className="content-page__inline-link" to="/shipping" onClick={scrollToTop}>
                delivery guide
              </Link>
              .
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="return-costs">
            <h2 id="return-costs">Return shipping and non-returnable items</h2>
            <p>
              sickzuno will provide instructions when an incorrect, damaged or verified
              defective item needs to be returned. For an eligible preference-based
              return, the customer may be responsible for return shipping where law
              permits. Personalized goods, gift cards, opened food and items marked final
              sale are not normally returnable unless defective or required by law.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="return-rights">
            <h2 id="return-rights">Consumer rights</h2>
            <p>
              This policy does not limit a refund, replacement, cancellation or other
              remedy that cannot be excluded under applicable consumer law. The{" "}
              <Link className="content-page__inline-link" to="/guarantee" onClick={scrollToTop}>
                Satisfaction Guarantee
              </Link>{" "}
              provides additional guidance for damaged, incorrect or materially
              misdescribed items.
            </p>
          </section>

          <aside className="content-page__support" aria-label="Returns support">
            <div>
              <h2>Start with customer care</h2>
              <p>Email harv@sickzuno.online or use the on-site contact form.</p>
            </div>
            <Link className="content-page__inline-link" to="/contact" onClick={scrollToTop}>
              Send return details
            </Link>
          </aside>
        </article>
      </div>
    </main>
  );
}

export default Returns;
